import { createContext } from 'react'

export const CashierNotification = createContext()
